/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForSbomToResourceMappingAutomatic extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForSbomToResourceMappingAutomatic");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForSbomToResourceMappingAutomatic.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForSbomToResourceMappingAutomatic>): BackgroundJobPayloadForSbomToResourceMappingAutomatic {
        let obj = Object.assign(new BackgroundJobPayloadForSbomToResourceMappingAutomatic(), model);
        BackgroundJobPayloadForSbomToResourceMappingAutomatic.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForSbomToResourceMappingAutomatic>): BackgroundJobPayloadForSbomToResourceMappingAutomatic {
        if (!model) return null;
        return BackgroundJobPayloadForSbomToResourceMappingAutomatic.newInstance(<BackgroundJobPayloadForSbomToResourceMappingAutomatic> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForSbomToResourceMappingAutomatic) {
        if (!obj) return;

        models.BackgroundJobPayloadForSbomToResourceMappingAutomatic.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForSbomToResourceMappingAutomatic): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForSbomToResourceMappingAutomatic.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
